<ion-card *ngIf="document.serviceJob.servicedItem.plu">
  <ion-card-content>
      <ion-label>Accessories</ion-label>
      <ion-fab vertical="center" horizontal="end" >
          <ion-row class="ion-no-margin ion-no-padding">
            <ion-fab-button (click)="editAccessories()" size="small" color="light">
               <ion-icon name="create"></ion-icon>
            </ion-fab-button>
          </ion-row>
      </ion-fab>
  </ion-card-content>

  <!--ion-list *ngIf="document.serviceJob.bundleItems.length > 0"-->
  <ion-list *ngIf="!customerRepairItem">
        <ion-item *ngFor="let item of document.serviceJob.bundleItems">
              <ion-label class="ion-text-wrap">
                  <p>{{item.qty}} - {{item.description}}</p>
              </ion-label>
        </ion-item>
  </ion-list>
  <ion-list *ngIf="customerRepairItem">
    <ion-item *ngFor="let item of customerRepairItem.bundleItems">
          <ion-label class="ion-text-wrap">
              <p>{{item.qty}} - {{item.description}}</p>
          </ion-label>
    </ion-item>
</ion-list>
</ion-card>